<template>
  <div v-if="title && description" class="alert bg-danger d-flex align-items-center p-5 mb-8">
    <i class="ki-duotone ki-notification-bing fs-2hx text-white me-4">
      <span class="path1"></span>
      <span class="path2"></span>
      <span class="path3"></span>
    </i>
    <div class="d-flex flex-column">
      <h4 class="mb-1 text-white">{{ title }}</h4>
      <span class="text-white" v-html="description"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertMain',
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>

</style>